<ui-list
    #list
    [dataSource]="feeds"
    selectionType="single"
    columnHeight="40px"
    [expandable]="false"
    [showHeader]="false"
    (selectionChange)="selectionChange($event)">
    <ui-list-column
        name="Name"
        property="name">
        <ng-template
            let-data="data"
            let-rowIndex="rowIndex"
            let-displayValue="displayValue"
            let-value="value"
            ui-list-cell-template>
            {{ data.name }}
        </ng-template>
    </ui-list-column>
</ui-list>
<div class="buttons">
    <ui-button
        text="Cancel"
        (click)="cancel()">
    </ui-button>
    <ui-button
        [disabled]="!selectedFeed"
        text="Select feed"
        (click)="confirmSelection($event)"
        type="primary">
    </ui-button>
</div>
